/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Claim Status Codes
 */
import { ANT_TAG_COLORS } from 'app-constants/antd';

export const CLAIM_STATUS_CODES = [
	{
		label: 'Acknowledged - Forwarded',
		code: 'A0',
		title: 'Acknowledgement/Forwarded - The claim/encounter has been forwarded to another entity.',
		color: ANT_TAG_COLORS.purple,
		order: 16,
	},
	{
		label: 'Acknowledged - Received',
		code: 'A1',
		title: 'Acknowledgement/Receipt - The claim/encounter has been received. This does not mean that the claim has been accepted for adjudication.',
		color: ANT_TAG_COLORS.purple,
		order: 15,
	},
	{
		label: 'Acknowledged - Accepted for Processing',
		code: 'A2',
		title: 'Acknowledgement/Acceptance into adjudication system - The claim/encounter has been accepted into the adjudication system.',
		color: ANT_TAG_COLORS.purple,
		order: 14,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'A3',
		title: 'Acknowledgement/Returned as unprocessable claim - The claim/encounter has been rejected and has not been entered into the adjudication system.',
		color: ANT_TAG_COLORS.purple,
		order: 13,
	},
	{
		label: 'Acknowledged - Not Found',
		code: 'A4',
		title: 'Acknowledgement/Not Found - The claim/encounter can not be found in the adjudication system.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Split',
		code: 'A5',
		title: 'Acknowledgement/Split Claim - The claim/encounter has been split upon acceptance into the adjudication system.',
		color: ANT_TAG_COLORS.purple,
		order: 18,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'A6',
		title: 'Acknowledgement/Rejected for Missing Information - The claim/encounter is missing the information specified in the Status details and has been rejected.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'A7',
		title: 'Acknowledgement/Rejected for Invalid Information - The claim/encounter has invalid information as specified in the Status details and has been rejected.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'A8',
		title: 'Acknowledgement/Rejected for relational field in error.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Received',
		code: 'DR01',
		title: 'Acknowledgement/Receipt - The claim/encounter has been received. This does not mean the claim has been accepted into the data reporting/processing system. Usage: Can only be used in the Data Reporting Acknowledgement Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Accepted for Processing',
		code: 'DR02',
		title: 'Acknowledgement/Acceptance into the data reporting/processing system - The claim/encounter has been accepted into the data reporting/processing system. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'DR03',
		title: 'Acknowledgement/Returned as unprocessable claim - The claim/encounter has been rejected and has not been entered into the data reporting/processing system. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Not Found',
		code: 'DR04',
		title: 'Acknowledgement/Returned as unprocessable claim - The claim/encounter has been rejected and has not been entered into the data reporting/processing system. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
		order: 19,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'DR05',
		title: 'Acknowledgement/Rejected for Missing Information - The claim/encounter is missing the information specified in the Status details and has been rejected. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'DR06',
		title: 'Acknowledgment/Rejected for invalid information - The claim/encounter has invalid information as specified in the Status details and has been rejected. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Rejected for Processing',
		code: 'DR07',
		title: 'Acknowledgement/Rejected for relational field in error. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
	},
	{
		label: 'Acknowledged - Accepted with Warning',
		code: 'DR08',
		title: 'Acknowledgement/Warning - The claim/encounter has been accepted into the data reporting/processing system but has received a warning as specified in the Status details. Usage: Can only be used in the Data Reporting Acknowledgment Transaction.',
		color: ANT_TAG_COLORS.purple,
		order: 17,
	},
	{
		label: 'Pending',
		code: 'P0',
		title: 'Pending: Adjudication/Details - This is a generic message about a pended claim. A pended claim is one for which no remittance advice has been issued, or only part of the claim has been paid.',
		color: ANT_TAG_COLORS.gold,
		order: 3,
	},
	{
		label: 'Pending',
		code: 'P1',
		title: 'Pending/In Process - The claim or encounter is in the adjudication system.',
		color: ANT_TAG_COLORS.gold,
	},
	{
		label: 'Pending',
		code: 'P2',
		title: 'Pending/Payer Review - The claim/encounter is suspended and is pending review (e.g. medical review, repricing, Third Party Administrator processing).',
		color: ANT_TAG_COLORS.gold,
	},
	{
		label: 'Pending',
		code: 'P3',
		title: 'Pending/Provider Requested Information - The claim or encounter is waiting for information that has already been requested from the provider. (Usage: A Claim Status Code identifying the type of information requested, must be reported).',
		color: ANT_TAG_COLORS.gold,
	},
	{
		label: 'Pending',
		code: 'P4',
		title: 'Pending/Patient Requested Information - The claim or encounter is waiting for information that has already been requested from the patient. (Usage: A status code identifying the type of information requested must be sent).',
		color: ANT_TAG_COLORS.gold,
	},
	{
		label: 'Pending',
		code: 'P5',
		title: 'Pending/Payer Administrative/System hold.',
		color: ANT_TAG_COLORS.gold,
	},
	{
		label: 'Finalized - Complete, No Further Action',
		code: 'F0',
		title: 'Finalized - The claim/encounter has completed the adjudication cycle and no more action will be taken.',
		color: ANT_TAG_COLORS.blue,
		order: 8,
	},
	{
		label: 'Paid',
		code: 'F1',
		title: 'Finalized/Payment - The claim/line has been paid.',
		color: ANT_TAG_COLORS.green,
		order: 1,
	},
	{
		label: 'Denied',
		code: 'F2',
		title: 'Finalized/Denial - The claim/line has been denied.',
		color: ANT_TAG_COLORS.red,
		order: 2,
	},
	{
		label: 'Finalized - Revised',
		code: 'F3',
		title: 'Finalized/Revised - Adjudication information has been changed.',
		color: ANT_TAG_COLORS.blue,
		order: 9,
	},
	{
		label: 'Finalized - Forwarded',
		code: 'F3F',
		title: "Finalized/Forwarded - The claim/encounter processing has been completed. Any applicable payment has been made and the claim/encounter has been forwarded to a subsequent entity as identified on the original claim or in this payer's records.",
		color: ANT_TAG_COLORS.blue,
		order: 10,
	},
	{
		label: 'Finalized - Not Forwarded',
		code: 'F3N',
		title: 'Finalized/Not Forwarded - The claim/encounter processing has been completed. Any applicable payment has been made. The claim/encounter has NOT been forwarded to any subsequent entity identified on the original claim.',
		color: ANT_TAG_COLORS.blue,
		order: 11,
	},
	{
		label: 'Finalized - No Payment Forthcoming',
		code: 'F4',
		title: 'Finalized/Adjudication Complete - No payment forthcoming - The claim/encounter has been adjudicated and no further payment is forthcoming.',
		color: ANT_TAG_COLORS.blue,
		order: 12,
	},
	{
		label: 'Additional Information Required',
		code: 'R0',
		title: "Requests for additional Information/General Requests - Requests that don't fall into other R-type categories.",
		color: ANT_TAG_COLORS.default,
		order: 4,
	},
	{
		label: 'Additional Information Required',
		code: 'R1',
		title: 'Requests for additional Information/Entity Requests - Requests for information about specific entities (subscribers, patients, various providers).',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R3',
		title: 'Requests for additional Information/Claim/Line - Requests for information that could normally be submitted on a claim.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R4',
		title: 'Requests for additional Information/Documentation - Requests for additional supporting documentation. Examples: certification, x-ray, notes.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R5',
		title: 'Request for additional information/more specific detail - Additional information as a follow up to a previous request is needed. The original information was received but is inadequate. More specific/detailed information is requested.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R6',
		title: 'Requests for additional information – Regulatory requirements.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R7',
		title: 'Requests for additional information – Confirm care is consistent with Health Plan policy coverage.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R8',
		title: 'Requests for additional information – Confirm care is consistent with health plan coverage exceptions.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R9',
		title: 'Requests for additional information – Determination of medical necessity.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R10',
		title: 'Requests for additional information – Support a filed grievance or appeal.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R11',
		title: 'Requests for additional information – Pre-payment review of claims.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R12',
		title: 'Requests for additional information – Clarification or justification of use for specified procedure code.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R13',
		title: 'Requests for additional information – Clarification or justification of use for specified procedure code.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R14',
		title: 'Requests for additional information – Original documents received are not what was requested. Used only for subsequent request(s).',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R15',
		title: 'Requests for additional information – Workers Compensation coverage determination.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R16',
		title: 'Requests for additional information – Eligibility determination.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Additional Information Required',
		code: 'R17',
		title: 'Replacement of a Prior Request. Used to indicate that the current attachment request replaces a prior attachment request.',
		color: ANT_TAG_COLORS.default,
	},
	{
		label: 'Input Error',
		code: 'E0',
		title: 'Response not possible - error on submitted request data.',
		color: ANT_TAG_COLORS.orange,
		order: 5,
	},
	{
		label: 'Network Error',
		code: 'E1',
		title: 'Response not possible - System Status.',
		color: ANT_TAG_COLORS.magenta,
		order: 6,
	},
	{
		label: 'Network Error',
		code: 'E2',
		title: 'Information Holder is not responding; resubmit at a later time.',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'Input Error',
		code: 'E3',
		title: 'Correction required - relational fields in error.',
		color: ANT_TAG_COLORS.orange,
	},
	{
		label: 'Input Error',
		code: 'E4',
		title: 'Trading partner agreement specific requirement not met: Data correction required. (Usage: A status code identifying the type of information requested must be sent).',
		color: ANT_TAG_COLORS.orange,
	},
	{
		label: 'Input Error',
		code: 'D0',
		title: 'Data Search Unsuccessful - The payer is unable to return status on the requested claim(s) based on the submitted search criteria.',
		color: ANT_TAG_COLORS.orange,
	},
	{
		label: 'Input Error',
		code: 'InputError',
		title: 'Input Error',
		color: ANT_TAG_COLORS.orange,
	},
	{
		label: 'Implementation Error',
		code: 'ValidationError',
		title: 'Implementation Error',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'Network Error',
		code: 'NetworkError',
		title: 'Network Error',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'Implementation Error',
		code: 'ServerError',
		title: 'Implementation Error',
		color: ANT_TAG_COLORS.magenta,
		order: 7,
	},
	{
		label: 'Implementation Error',
		code: 'AuthError',
		title: 'Implementation Error',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'Implementation Error',
		code: 'ServiceError',
		title: 'Implementation Error',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'Implementation Error',
		code: 'ServiceAuthError',
		title: 'Implementation Error',
		color: ANT_TAG_COLORS.magenta,
	},
	{
		label: 'No Response Error',
		code: 'NoResponseError',
		title: 'No Response Error',
		color: ANT_TAG_COLORS.default,
		order: 7,
	},
];
